module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/Sonos-7098857a52db85f1f6e3d72115c31896.png";